module.exports = __webpack_public_path__ + "static/media/edu-games-plus-logo-black.202270b5.svg";